<template>
  <div>
    <ap-link :revalStatus="revalidationStatus" href="https://apdirect.airproducts.com/Invoice/AcctStmt">
      <div class="pay-online-icon"></div>
      <div class="pay-online-text" v-html="$t('ml_107027')">x-Pay Online</div>
    </ap-link>
  </div>
</template>

<script>
import ApLink from '@/components/APLink.vue'

export default {
  name: 'PayOnline',
  components: {
    ApLink
  },
  computed: {
    revalidationStatus() {
      return this.$store.state.revalidationStatus
    }
  }

}
</script>

<style scoped>
.pay-online-icon {
  width: 35px;
  height: 35px;
  margin-right: 15px;
  background: url(./../assets/icons/pay_online.gif);
  float: left;
}

.pay-online-text {
  float: left;
}

a,
a:active,
a:visited {
  text-decoration: none;
}
</style>
